import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import {
  Alert,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Badge,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
} from 'reactstrap';
import {
  calculateCartTotal,
  capitalize,
  createHash,
  getAvailableItemAdditionGroups,
  getCartOrderConditionViolations,
  getCurrentAtDate,
  getEffectiveRequestedAt,
  getNextStart,
  getOrderErrorMessage,
  getActiveOrderConfig,
  isCartOrderConditionsSatisfiedAtDate,
  isCustomerDetailRequired,
  getTipSettings,
  isCartCommentAllowed,
  getServiceFeeFromConfig,
  getCheckoutMethodFromConfig,
  cartHasPosConflictForConfig,
  getOrderPathType,
  hasEnabledNotificationMethods,
} from '../../../../utility/util/util.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect, useStore } from 'react-redux';
import {
  setCart,
  setCheckout,
  setOrder,
  setOrderHash,
  removeCartItem,
  fetchDailyLimitsAction,
} from '../../../../redux/store/store.actions';
import {
  setIsCartModalOpen,
  setIsCheckoutModalOpen,
  setIsOrderInfoModalOpen,
  setIsTipModalOpen,
  setIsChoosePaymentMethodModalOpen,
  setOrderInfoModalData,
  setSelectAdditionsModalData,
  setIsSelectAdditionsModalOpen,
  setCreateDeliveryAddressModalData,
  setIsCreateDeliveryAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsCreateBillingAddressModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
} from '../../../../redux/modal/modal.actions';
import classnames from 'classnames';
import { ShoppingBag } from 'react-feather';
import {
  CHECKOUT_METHOD_ORDER_AND_PAY,
  CHECKOUT_METHOD_ORDER_ONLY,
  CHECKOUT_METHOD_PAY_AND_GO,
  ORDER_TYPE_CATERING,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_INHOUSE,
  ORDER_TYPE_PICKUP,
  ORDER_TYPE_SELF_SERVICE,
} from '../../../../utility/constants';
import { buildOrderItemByIds, createOrder } from './cart.service';
import { fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import {
  notification,
  notificationFormattedMessage,
} from '../../../../utility/notification/notification.service';
import {
  getCustomerProfile,
  updateCustomerProfile,
  getDailyLimits,
  updateOrderV2,
} from '../../../../utility/sb-api/sb-api.service';
import SelectRelevo from '../../selectors/select-relevo/select-relevo.component';
import SelectOrderType from '../../selectors/select-order-type/select-order-type.component';
import SelectCheckoutMethod from '../../selectors/select-checkout-method/select-checkout-method.component';
import OrderItemLine from './order-item-line.component';
import Empty from '../../../../views/errors/empty.component';
import TermsAndConditionsText from '../../helpers/agreementText.component';
import { SocketContext } from '../../../../context/socket.context';
import { calculateDistance } from '../../../../utility/util/util.service';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import FormField from '../../form/fields/FormField';
import { AvForm, AvInput } from 'availity-reactstrap-validation';
import { useLocation } from 'react-router-dom';
import * as Icon from 'react-feather';
import TelFormField from '../../form/fields/TelFormField';
import DateTimeField from '../../form/fields/DateTimeField';
import { DateTime } from 'luxon';
import OptionsList from '../../selectors/options-list/options-list.component';
import { debounce } from 'debounce';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import DropdownField from '../../form/fields/DropdownField';

const CartModal = ({
  isOpen,
  cart,
  store,
  table,
  checkout,
  me,
  order,
  sharedCarts,
  menuEntriesData,
  billingAddresses,
  deliveryAddresses,
  kiosk,
  tables,
  items,

  setIsCartModalOpen,
  setCheckout,
  setIsTipModalOpen,
  setIsChoosePaymentMethodModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  fetchOnAuthenticated,
  setOrder,
  setOrderHash,
  setCart,
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  setIsCheckoutModalOpen,
  setSelectAdditionsModalData,
  setIsSelectAdditionsModalOpen,
  removeCartItem,
  setIsCreateBillingAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsCreateDeliveryAddressModalOpen,
  setCreateDeliveryAddressModalData,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
}) => {
  const intl = useIntl();
  const reduxStore = useStore();
  const cartHash = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  // Synchronous re-entry guard. React state updates are async, so on a slow
  // connection the button could be clicked again before `isLoading` re-renders.
  const isCreatingOrderRef = useRef(false);
  const [showItemAddedAnimation, setShowItemAddedAnimation] = useState(false);
  const [showTableDropdown, setShowTableDropdown] = useState(false);
  const [preparedSharedCarts, setPreparedSharedCarts] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [isWithinDeliveryRadius, setIsWithinDeliveryRadius] = useState(false);
  const [isDateTimeFieldValid, setIsDateTimeFieldValid] = useState(true);
  const [customerProfile, setCustomerProfile] = useState(null);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const formRef = useRef(null);
  const hasPrefilledCustomerInfo = useRef(false);
  // Support both old (me?.requester?.customerProfile) and new (me?.customerProfileId) API structures
  const customerProfileId =
    me?.customerProfileId || me?.requester?.customerProfile?.id;

  // Use orderType for calculations, fallback to PICKUP when no orderType is set
  const priceOrderType = checkout?.orderType || ORDER_TYPE_PICKUP;

  // Get the active order config based on current context (table, kiosk, order type)
  const activeOrderConfig = getActiveOrderConfig(
    store,
    priceOrderType,
    table,
    kiosk,
  );

  // Get settings from order config
  const tipSettings = getTipSettings(activeOrderConfig);
  const enableTips = tipSettings.allowTip;
  const enableCartComment = isCartCommentAllowed(activeOrderConfig);
  const serviceFee = getServiceFeeFromConfig(activeOrderConfig);

  // Customer detail requirements from order config
  const enableCustomerName = isCustomerDetailRequired(
    activeOrderConfig,
    'name',
  );
  const enableCustomerTel = isCustomerDetailRequired(activeOrderConfig, 'tel');
  const enableCustomerEmail = isCustomerDetailRequired(
    activeOrderConfig,
    'email',
  );
  const enableCustomerRoomNumber = isCustomerDetailRequired(
    activeOrderConfig,
    'room_number',
  );

  // Pre-order hours from order config (for pickup, delivery, catering)
  const preOrderHours = activeOrderConfig?.preOrderHours || 0;

  // Delivery fees from active order config (delivery or catering)
  const deliveryFees = activeOrderConfig?.deliveryFees || [];

  // Pager number setting from inhouse order config
  const enablePagerNumber =
    store?.inhouseOrderConfig?.enablePagerNumber || false;

  // Accumulated orders CSV time from merchantProfile (merchant-level setting for CSV reporting)
  const accumulatedOrdersCsvTime =
    store?.merchantProfile?.accumulatedOrdersCsvTime;

  const isDeliveryOrder = checkout?.orderType === ORDER_TYPE_DELIVERY;
  const isCateringOrder = checkout?.orderType === ORDER_TYPE_CATERING;
  const isPickupOrder = checkout?.orderType === ORDER_TYPE_PICKUP;
  const isInhouseOrder = checkout?.orderType === ORDER_TYPE_INHOUSE;
  const isSelfServiceOrder = checkout?.orderType === ORDER_TYPE_SELF_SERVICE;

  const isOrderOnly = checkout?.checkoutMethod === CHECKOUT_METHOD_ORDER_ONLY;
  const isOrderAndPay =
    checkout?.checkoutMethod === CHECKOUT_METHOD_ORDER_AND_PAY;

  // The effective checkout method mirrors handleCreateOrder: an explicit, still
  // valid customer choice wins, otherwise fall back to the config/area default.
  // Order_only orders never open the checkout modal (where the discount field
  // otherwise lives), so we surface the discount field in the cart for them.
  const allowedCheckoutMethods =
    activeOrderConfig?.allowedCheckoutMethods || [];
  const effectiveCheckoutMethod =
    !table?.area?.checkoutMethod &&
    checkout?.checkoutMethod &&
    allowedCheckoutMethods.includes(checkout.checkoutMethod)
      ? checkout.checkoutMethod
      : getCheckoutMethodFromConfig(activeOrderConfig, table?.area, {
          table,
          store,
          orderType: checkout?.orderType,
        });
  // Discount codes can be disabled per order type via OrderConfig.allowDiscountCode.
  const showDiscountInCart =
    effectiveCheckoutMethod === CHECKOUT_METHOD_ORDER_ONLY &&
    activeOrderConfig?.allowDiscountCode !== false;

  // Check if cart contains items or additions incompatible with the selected
  // order type's POS integration (an ItemData/ItemAddition without a
  // posIntegrationRef cannot be synced to that POS).
  const hasCartPosConflict = cartHasPosConflictForConfig(
    activeOrderConfig,
    cart,
  );

  const itemsTotal = calculateCartTotal(priceOrderType, cart);
  const socketContext = useContext(SocketContext);
  const [courseCart, setCourseCart] = useState(null);
  const [discountCodeInvalid, setDiscountCodeInvalid] = useState(false);
  // Local text for the order_only cart discount field. The code is only
  // committed to `checkout.discountCode` (and thus sent when the order is
  // created) once the shopper presses "apply".
  const [discountCodeInput, setDiscountCodeInput] = useState(
    checkout?.discountCode || '',
  );
  const setCheckoutDebouncedRef = useRef(debounce(setCheckout, 350));
  const setCheckoutDebounced = setCheckoutDebouncedRef.current;

  // Debounced function to patch customer profile (persisted via ref to survive re-renders)
  const patchCustomerProfileDebouncedRef = useRef(
    debounce((customerProfileIdVal, payload, setCustomerProfileFn) => {
      if (customerProfileIdVal) {

        updateCustomerProfile(customerProfileIdVal, payload)
          .then((updatedProfile) => {
            console.log('[Cart] Customer profile patched:', updatedProfile);
            setCustomerProfileFn(updatedProfile);
          })
          .catch((err) => {
            console.error('[Cart] Failed to patch customer profile:', err);
          });
      }
    }, 500),
  );
  const patchCustomerProfileDebounced = patchCustomerProfileDebouncedRef.current;

  // determine that given DeliveryAddress is within Stores delivery radius

  const toggleActiveTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // triggers the item added animation
  useEffect(() => {
    const newCartHash = createHash(cart);
    if (cartHash?.current !== newCartHash) {
      if (cartHash?.current !== null) {
        setShowItemAddedAnimation(true);
      }
      cartHash.current = newCartHash;
    }
  }, [cart]);

  // handle selfServiceTableSelection
  useEffect(() => {
    // If user is already on a table (joined via table URL), skip table selection
    // The table info is already available from the table context
    if (table) {
      setShowTableDropdown(false);
      return;
    }

    // Get self-service order config
    const selfServiceConfig = store?.selfServiceOrderConfig;
    const tableSelectionMode = selfServiceConfig?.tableSelectionMode;

    if (
      cart &&
      tableSelectionMode &&
      tableSelectionMode !== 'never' &&
      checkout?.orderType === ORDER_TYPE_SELF_SERVICE
    ) {
      // If tableSelectionMode is 'always', always show table selection
      if (tableSelectionMode === 'always') {
        if (!checkout?.tableId) {
          setIsSelfServiceTableSelectionModalOpen(true);
        }
        setShowTableDropdown(true);
        setSelfServiceTableSelectionModalData({
          showReducedModal: true,
        });
        return;
      }

      // If tableSelectionMode is 'item_categories', check if any cart items are in the required categories
      if (tableSelectionMode === 'item_categories') {
        // get all Item IDs added to cart
        const itemIdsAddedToCart = [
          ...new Set(
            cart
              ?.map((orderItem) => orderItem?.itemData?.item?.id)
              .filter(Boolean),
          ),
        ];

        // get all ItemCategory IDs, with Items from them added to cart
        const categoryIdsWithItemsInCart = itemIdsAddedToCart
          .flatMap((id) => items?.find((item) => id === item?.id)?.categories)
          .filter(Boolean)
          .map(({ id }) => id);

        // extract IDs from categories that require table selection
        const selfServiceTableSelectionCategoryIds = (
          selfServiceConfig?.requiredTableSelectionForItemCategories || []
        ).map(({ id }) => id);

        // if categoryIdsWithItemsInCart and selfServiceTableSelectionCategoryIds overlap, show the Table Dropdown
        const showTableDropdownForCategories = categoryIdsWithItemsInCart?.some(
          (id) => selfServiceTableSelectionCategoryIds.includes(id),
        );
        if (showTableDropdownForCategories && !checkout?.tableId) {
          setIsSelfServiceTableSelectionModalOpen(true);
        }
        setShowTableDropdown(!!showTableDropdownForCategories);
        setSelfServiceTableSelectionModalData({
          showReducedModal: true,
        });
      }
    }
  }, [cart, store?.selfServiceOrderConfig, table]);

  // exclude users own cart and build the items from itemIds.
  // Filter by the customerProfileId derived from `me` (the same value the
  // backend stamps onto SharedCart entries in
  // table-websocket.service.updateSharedCart) instead of the locally
  // fetched `customerProfile?.id`, which is undefined until the async
  // getCustomerProfile() call completes and would otherwise make our own
  // cart show up as "another guest" on first render.
  useEffect(() => {
    if (me && sharedCarts) {
      const ownCarts = sharedCarts.filter(
        (c) => c.customerProfileId === customerProfileId,
      );
      const otherCarts = sharedCarts.filter(
        (c) => c.customerProfileId !== customerProfileId,
      );
      if (otherCarts.length === 0 || ownCarts.length + otherCarts.length === 1) {
        setActiveTab('1');
      }
      setPreparedSharedCarts(
        otherCarts.map((sharedCart) => {
          const items =
            sharedCart.items?.map((orderItem) =>
              buildOrderItemByIds(menuEntriesData, orderItem),
            ) || [];
          return { ...sharedCart, items };
        }),
      );
    }
  }, [me, customerProfileId, sharedCarts, menuEntriesData]);

  // handle course cart init and change
  useEffect(() => {
    if (cart?.length) {
      const filterByCourse = (expected) =>
        cart.filter(
          ({ type, course }) => type === 'OrderItem' && course === expected,
        );
      const course0OrderItems = filterByCourse(0);
      const course1OrderItems = filterByCourse(1);
      const course2OrderItems = filterByCourse(2);
      const course3OrderItems = filterByCourse(3);

      if (
        cart.length === 1 ||
        cart.every(({ itemData }) => itemData.defaultCourse === 0) ||
        !table
      ) {
        setCourseCart(null); // don't use it if only one item or only defaultCourse=0 items
      } else {
        const courseCart = [
          ...course0OrderItems,
          { type: 'Course', course: 1 },
          ...course1OrderItems,
          { type: 'Course', course: 2 },
          ...course2OrderItems,
          { type: 'Course', course: 3 },
          ...course3OrderItems,
        ];
        setCourseCart(courseCart);
      }
    }
  }, [cart]);

  // Fetch customer profile when modal opens
  useEffect(() => {
    console.log('[Cart] Fetch customer profile effect:', {
      isOpen,
      customerProfileId,
      customerProfile,
      me,
    });
    if (isOpen && customerProfileId && !customerProfile) {
      console.log('[Cart] Fetching customer profile:', customerProfileId);
      getCustomerProfile(customerProfileId)
        .then((profile) => {
          console.log('[Cart] Customer profile fetched:', profile);
          setCustomerProfile(profile);
        })
        .catch((err) => {
          console.error('[Cart] Failed to fetch customer profile:', err);
        });
    }
  }, [isOpen, customerProfileId]);

  // Reset prefill flag when modal closes
  useEffect(() => {
    if (!isOpen) {
      hasPrefilledCustomerInfo.current = false;
    }
  }, [isOpen]);

  // Keep the discount field in sync with the committed code when the cart opens
  // (e.g. after a reset the redux code is cleared, so the field must clear too).
  useEffect(() => {
    if (isOpen) {
      setDiscountCodeInput(checkout?.discountCode || '');
      setDiscountCodeInvalid(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // set default checkout values
  useEffect(() => {
    console.log('[Cart] Prefill effect:', {
      isOpen,
      checkout,
      store: !!store,
      customerProfile,
      hasPrefilledCustomerInfo: hasPrefilledCustomerInfo.current,
    });
    if (isOpen && checkout && store && customerProfile) {
      console.log('[Cart] Prefilling from customer profile:', customerProfile);
      const update = {
        // Only prefill customer info fields once to avoid overwriting user changes
        ...(!hasPrefilledCustomerInfo.current &&
          !checkout.customerName &&
          customerProfile.name && { customerName: customerProfile.name }),
        ...(!hasPrefilledCustomerInfo.current &&
          !checkout.customerTel &&
          customerProfile.tel && { customerTel: customerProfile.tel }),
        ...(!hasPrefilledCustomerInfo.current &&
          !checkout.customerEmail &&
          customerProfile.email && { customerEmail: customerProfile.email }),
        ...(isDeliveryOrder &&
          !checkout.deliveryAddressId &&
          deliveryAddresses?.length && {
            deliveryAddressId: deliveryAddresses[0].id,
          }),
        ...(isCateringOrder &&
          !checkout.billingAddressId &&
          billingAddresses?.length && {
            billingAddressId: billingAddresses[0].id,
          }),
        ...(isCateringOrder &&
          !checkout.deliveryAddressId &&
          deliveryAddresses?.length && {
            deliveryAddressId: deliveryAddresses[0].id,
          }),
        ...(isCateringOrder &&
          !checkout.deliveryRequestedAt && {
            deliveryRequestedAt: DateTime.now()
              .plus({ week: 1 })
              .toJSDate()
              .toISOString(),
          }),
        ...(!isCateringOrder &&
          checkout.deliveryRequestedAt && { deliveryRequestedAt: undefined }), // deliveryRequestedAt is just preset when CateringOrder
        // pickupRequestedAt only applies to PickupOrder — clear it on a switch
        // away so a stale time can never be used as the evaluation target or
        // leak into another order type's body.
        ...(!isPickupOrder &&
          checkout.pickupRequestedAt && { pickupRequestedAt: undefined }),
        ...(isPickupOrder &&
          store.serviceTimes?.length > 0 &&
          !checkout.pickupRequestedAt && {
            pickupRequestedAt: (getCurrentAtDate(store.serviceTimes)
              ? DateTime.min(
                  DateTime.now().plus({ minutes: 30 }), // default pickup in 30min
                  getCurrentAtDate(store.serviceTimes) &&
                    DateTime.fromJSDate(
                      getCurrentAtDate(store.serviceTimes).endAt,
                    ), // or end of current serviceTime
                )
              : DateTime.fromJSDate(getNextStart(store.serviceTimes).startAt)
            )
              .toJSDate()
              .toISOString(),
          }),
      };

      // Mark customer info as prefilled after first run
      if (!hasPrefilledCustomerInfo.current) {
        hasPrefilledCustomerInfo.current = true;
      }

      if (Object.keys(update)?.length) setCheckout(update);
    }
  }, [isOpen, store, customerProfile, checkout?.orderType]);

  const onCourseSortEnd = (sortEnd) => {
    const updatedCourseCart = arrayMove(
      courseCart,
      sortEnd.oldIndex,
      sortEnd.newIndex,
    );
    setCourseCart(updatedCourseCart);

    // loop over all Items, filter OrderItems only and assign courses. Update Cart then.
    let currentCourse = 0;
    const updatedCart = updatedCourseCart
      .map((item) => {
        if (item.type === 'OrderItem') {
          return { ...item, course: currentCourse };
        } else {
          currentCourse = item.course; // just update the course for next iteration
          return null;
        }
      })
      .filter(Boolean);

    setCart(updatedCart);
  };

  const handleAccumulatedOrdersCsvTime = (accumulatedOrdersCsvTime) => {
    const now = DateTime.now();

    const [hour, minute] = accumulatedOrdersCsvTime.split(':').map(Number);

    let pickupTimeToday = now.set({ hour, minute, second: 0, millisecond: 0 });

    let finalPickupTime;

    if (pickupTimeToday < now) {
      finalPickupTime = pickupTimeToday
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .plus({ days: 1 });
    } else {
      finalPickupTime = pickupTimeToday;
    }

    return finalPickupTime.toJSDate();
  };

  const CourseCartContainer = SortableContainer(({ courseCart }) => (
    <div className="course-cart-container">
      {courseCart?.map((item, index) =>
        item.type === 'OrderItem' ? (
          <CourseCartItemLine key={index} index={index} orderItem={item} />
        ) : (
          <CourseCartDivider
            key={index}
            index={index}
            course={item.course}
            disabled={true}
          />
        ),
      )}
    </div>
  ));

  const CourseCartItemLine = SortableElement(({ orderItem }) => (
    <OrderItemLine
      orderItem={orderItem}
      context="course_cart"
      handleEditItemAdditions={handleEditItemAdditions}
    />
  ));

  const getCourseCartDivider = (course) => (
    <Badge className="d-block w-100 mb-1" color="primary">
      <FormattedMessage id={`${course}CourseLabel`} />
    </Badge>
  );

  const CourseCartDivider = SortableElement(({ course }) =>
    getCourseCartDivider(course),
  );

  // Commit the typed code so it is sent when the order is created. There is no
  // order to validate against yet, so validity is confirmed at order creation
  // (a rejection is surfaced inline via `discountCodeInvalid`).
  const handleApplyCartDiscount = () => {
    const code = (discountCodeInput || '').trim();
    if (!code) return;
    setDiscountCodeInvalid(false);
    setDiscountCodeInput(code);
    setCheckout({ discountCode: code });
  };

  const handleRemoveCartDiscount = () => {
    setDiscountCodeInput('');
    setDiscountCodeInvalid(false);
    setCheckout({ discountCode: '' });
  };

  const handleCreateOrder = async () => {
    // Prevent duplicate submissions. On a slow connection the network calls
    // below take a while; without an immediate guard the button stays
    // clickable and repeated clicks create duplicate orders.
    if (isCreatingOrderRef.current) return;
    isCreatingOrderRef.current = true;
    setIsLoading(true);

    // Validate stock before proceeding
    const menuId = store?.menu?.id;
    if (menuId && cart?.length) {
      try {
        const freshLimits = await getDailyLimits(menuId);
        if (freshLimits?.length) {
          // Build cart qty map per itemData.id
          const cartQtyMap = {};
          cart.forEach(({ itemData: cartItemData, qty }) => {
            const id = cartItemData?.id;
            if (id) cartQtyMap[id] = (cartQtyMap[id] || 0) + qty;
          });

          for (const limit of freshLimits) {
            const cartQty = cartQtyMap[limit.itemDataId];
            if (cartQty && cartQty > limit.remaining) {
              if (limit.remaining === 0) {
                notificationFormattedMessage('error', 'stockValidationSoldOut');
              } else {
                notificationFormattedMessage(
                  'error',
                  'stockValidationExceeds',
                  { remaining: limit.remaining },
                );
              }
              reduxStore.dispatch(fetchDailyLimitsAction(menuId));
              isCreatingOrderRef.current = false;
              setIsLoading(false);
              return;
            }
          }
        }
      } catch (e) {
        // If validation fails, continue — backend will catch it
      }
    }

    // Validate OrderConditions across the whole cart, mirroring the backend
    // checks (ItemData, order-wide ItemAddition, and group/entry levels) at the
    // effective fulfillment time. This prevents placing an order that the
    // backend would reject with one of the *_ORDER_CONDITION_NOT_SATISFIED
    // errors.
    const effectiveRequestedAt = getEffectiveRequestedAt(checkout);
    const orderConditionViolations = getCartOrderConditionViolations(
      cart,
      checkout?.orderType,
      effectiveRequestedAt ?? new Date(),
    );
    if (orderConditionViolations.length > 0) {
      console.debug('[Cart] OrderCondition violations:', orderConditionViolations);
      const flat = orderConditionViolations.flatMap(({ violations }) => violations);
      // Only blame the requested time when one was actually chosen; otherwise
      // the generic combination error is the honest wording.
      const isTimeViolation =
        !!effectiveRequestedAt &&
        flat.some(({ type }) => type === 'serviceTimeMismatch');
      notificationFormattedMessage(
        'warning',
        isTimeViolation
          ? 'itemUnavailableAtRequestedTimeError'
          : 'addToCartOrderConditionsError',
      );
      isCreatingOrderRef.current = false;
      setIsLoading(false);
      return;
    }

    const handleOpenNextModal = () => {
      // Check if we should show payment method chooser (kiosk mode + TWINT enabled)
      const shouldShowPaymentMethodChooser =
        kiosk &&
        store?.paymentProcessor?.enabledPaymentMethods?.includes('twint');

      // Close cart modal first
      setIsCartModalOpen(false);

      if (enableTips) {
        setIsTipModalOpen(true);
      } else if (shouldShowPaymentMethodChooser) {
        setIsChoosePaymentMethodModalOpen(true);
      } else if (
        // Mirror the tip-modal gate: with tips disabled this was the only
        // place the pre-checkout notification prompt lived, so order_and_pay
        // stores without tips skipped the step entirely. pay_and_go is
        // excluded: the inhouse table flow already collected the method when
        // the order_only items were added (see table-cart).
        !kiosk &&
        correctCheckoutMethod !== CHECKOUT_METHOD_PAY_AND_GO &&
        hasEnabledNotificationMethods(activeOrderConfig)
      ) {
        setOrderNotificationsModalData({
          proceedToCheckout: true,
          checkout: checkoutWithCorrectMethod,
        });
        setIsOrderNotificationsModalOpen(true);
      } else {
        setIsCheckoutModalOpen(true);
      }
    };

    // Ensure the correct checkout method is used based on current context
    // This handles cases where the checkout state might have been set before the logic was updated.
    // Preserve an explicit, still-valid customer choice (SelectCheckoutMethod)
    // instead of forcing the config default when both methods are allowed.
    const allowedCheckoutMethods =
      activeOrderConfig?.allowedCheckoutMethods || [];
    const customerChoiceIsValid =
      !table?.area?.checkoutMethod &&
      checkout?.checkoutMethod &&
      allowedCheckoutMethods.includes(checkout.checkoutMethod);
    const correctCheckoutMethod = customerChoiceIsValid
      ? checkout.checkoutMethod
      : getCheckoutMethodFromConfig(activeOrderConfig, table?.area, {
          table,
          store,
          orderType: checkout?.orderType,
        });
    const checkoutWithCorrectMethod =
      correctCheckoutMethod &&
      correctCheckoutMethod !== checkout?.checkoutMethod
        ? { ...checkout, checkoutMethod: correctCheckoutMethod }
        : checkout;

    // Update checkout state if needed
    if (
      correctCheckoutMethod &&
      correctCheckoutMethod !== checkout?.checkoutMethod
    ) {
      setCheckout({ checkoutMethod: correctCheckoutMethod });
    }

    // only create the Order here initially! If something has changed, Order will be updated during Checkout.
    if (!order || order.type !== checkout.orderType) {
      createOrder(
        me,
        order,
        checkoutWithCorrectMethod,
        cart,
        store,
        setOrder,
        setOrderHash,
        fetchOnAuthenticated,
        intl,
        table,
        kiosk,
        socketContext?.setToken,
        () => reduxStore.getState().auth?.me, // get fresh me from Redux store
        customerProfile, // pass existing customer profile to avoid extra fetch
      )
        .then((order) => {
          isCreatingOrderRef.current = false;
          setIsLoading(false);

          // if order_only or free order, skip tip modal and checkout
          if (
            order.checkoutMethod === CHECKOUT_METHOD_ORDER_ONLY ||
            order.total === 0
          ) {
            const showNotifications =
              !kiosk && hasEnabledNotificationMethods(activeOrderConfig);

            if (showNotifications) {
              // Mirror the order_and_pay flow: prompt for the notification
              // method BEFORE finalizing. The prompt is closable (the customer
              // can dismiss it, go back to the menu and add more items) but
              // cannot finalize without choosing a method. The order is only
              // submitted once they confirm, from inside the modal, so a
              // dismissed order is never placed.
              setIsCartModalOpen(false);
              setOrderNotificationsModalData({
                order,
                orderOnlyCheckout: true,
              });
              setIsOrderNotificationsModalOpen(true);
            } else {
              // No notification methods to choose: submit right away and show
              // the confirmation. Neither order_only nor a free (total=0)
              // order_and_pay order has a payment webhook to advance it, so we
              // submit explicitly (like the kiosk) to leave PENDING.
              // Re-send the applied discount code with the submit so the
              // discount is deterministic and survives the status change
              // regardless of which relations the backend loads on update.
              const pathType = getOrderPathType(order.type);
              const appliedDiscountCode =
                order?.discountCode?.code || checkout?.discountCode;
              const submitPromise = pathType
                ? updateOrderV2(pathType, order.id, {
                    status: 'submitted',
                    ...(appliedDiscountCode && {
                      discountCode: appliedDiscountCode,
                    }),
                  }).catch(() => order)
                : Promise.resolve(order);
              submitPromise.then((submitted) => {
                const finalOrder = submitted || order;
                setIsCartModalOpen(false);
                setCheckout(null);
                setOrder(null);
                setOrderHash(null);
                setCart(null);
                setOrderInfoModalData({ order: finalOrder, isInitial: true });
                setIsOrderInfoModalOpen(true);
              });
            }
          } else if (order.isTest) {
            // Test mode: the backend settled a synthetic payment (order is
            // already PAID) and no card is ever charged, so skip the Stripe
            // checkout and go straight to the confirmation, mirroring the
            // order_only success path.
            setIsCartModalOpen(false);
            setCheckout(null);
            setOrder(null);
            setOrderHash(null);
            setCart(null);
            setOrderInfoModalData({ order, isInitial: true });
            setIsOrderInfoModalOpen(true);
          } else {
            handleOpenNextModal();
          }
        })
        .catch((err) => {
          console.error('[Cart] Order creation error:', err);
          isCreatingOrderRef.current = false;
          setIsLoading(false);

          const errorCode = err?.response?.data?.error;
          const isDiscountError =
            typeof errorCode === 'string' &&
            errorCode.startsWith('DISCOUNT_CODE');

          // A rejected discount code must not close the cart: keep it open, flag
          // the field inline so the shopper can fix or remove the code, and
          // still surface the toast (mirrors the checkout modal for order_only).
          if (isDiscountError) {
            setDiscountCodeInvalid(true);
          } else {
            setIsCartModalOpen(false);
          }

          notificationFormattedMessage('error', getOrderErrorMessage(err), {
            storeName: store?.name,
            error: errorCode || err?.message || String(err),
          });
          // Refresh daily limits so the menu reflects current state
          if (errorCode === 'ITEM_DATA_DAILY_LIMIT_EXCEEDED') {
            reduxStore.dispatch(fetchDailyLimitsAction(store?.menu?.id));
          }
        });
    } else {
      isCreatingOrderRef.current = false;
      setIsLoading(false);
      handleOpenNextModal();
    }
  };

  const handleEditItemAdditions = (orderItem) => {
    // need to decide whether to open the select-additions modal or not.
    const itemAdditionGroups = getAvailableItemAdditionGroups(
      orderItem.itemData?.additionGroups,
      priceOrderType,
      activeOrderConfig?.posIntegration,
      getEffectiveRequestedAt(checkout),
    );

    if (itemAdditionGroups?.length > 0) {
      removeCartItem(cart, orderItem?.hash);
      setSelectAdditionsModalData({
        itemData: orderItem.itemData,
        editOrderItem: orderItem,
        itemAdditionGroups,
      });
      setIsSelectAdditionsModalOpen(true);
    }
  };

  // Use order config for customer detail requirements
  const showCustomerNameField = enableCustomerName;
  const showCustomerTelField = enableCustomerTel;
  const showCustomerEmailField = enableCustomerEmail;
  const showCustomerRoomNumberField = enableCustomerRoomNumber;
  const customerFieldsQty =
    (showCustomerNameField ? 1 : 0) +
    (showCustomerTelField ? 1 : 0) +
    (showCustomerEmailField ? 1 : 0) +
    (showCustomerRoomNumberField ? 1 : 0);

  // Pre-order hours from order config (convert to days for backward compatibility)
  const preOrderDays = Math.ceil(preOrderHours / 24);

  const targetDate = DateTime.now()
    .plus({ days: preOrderDays })
    .toJSDate();
  const serviceTime = getCurrentAtDate(store?.serviceTimes, targetDate);

  const maxDate =
    preOrderDays > 0
      ? serviceTime
        ? DateTime.fromJSDate(targetDate)
            .set({
              hour: serviceTime.endAt.getHours(),
              minute: serviceTime.endAt.getMinutes(),
              second: serviceTime.endAt.getSeconds(),
            })
            .toJSDate()
        : DateTime.fromJSDate(targetDate)
            .set({ hour: 23, minute: 59, second: 59 }) // Default if no service time
            .toJSDate()
      : serviceTime
      ? DateTime.fromJSDate(serviceTime.endAt).toJSDate()
      : null;

  // The fulfillment time this order must be evaluated against: the chosen
  // pickup/delivery time for pre-order types, null for inhouse/self-service.
  // Derived via getEffectiveRequestedAt so a pickup time left in redux after
  // switching to an immediate order type can never be mistaken for the target
  // time (the backend validates against pickupRequestedAt ??
  // deliveryRequestedAt ?? now, and only ever reads those fields for their own
  // order type).
  const requestedFulfillmentDateObj = getEffectiveRequestedAt(checkout) ?? null;
  const isStoreOpenAtRequestedTime =
    !requestedFulfillmentDateObj ||
    !store?.serviceTimes?.length ||
    !!getCurrentAtDate(store.serviceTimes, requestedFulfillmentDateObj);
  // Availability of every OrderCondition scope (item data, addition, group and
  // entry level) at the chosen time. Qty/total limits stay out of this so a
  // minQty does not disable the button with an "unavailable at this time"
  // message — handleCreateOrder runs the full backend-equivalent check.
  const isItemsAvailableAtRequestedTime =
    !requestedFulfillmentDateObj ||
    isCartOrderConditionsSatisfiedAtDate(
      cart,
      checkout?.orderType,
      requestedFulfillmentDateObj,
    );

  // Immediate order types (self-service / in-house) have no requested
  // fulfillment time, so their items must be available *right now*. Pre-order
  // types (pickup/delivery/catering) are validated against the chosen time via
  // the DateTimeField instead. Without this check, an item whose OrderCondition
  // service-time window is closed now would silently pass the cart and only be
  // rejected by the backend on submit.
  const isImmediateOrderType = isSelfServiceOrder || isInhouseOrder;
  const isCartAvailableNow =
    !isImmediateOrderType ||
    isCartOrderConditionsSatisfiedAtDate(
      cart,
      checkout?.orderType,
      new Date(),
    );

  const formatRelative = (date) => {
    const now = DateTime.now();
    const dateTime = DateTime.fromJSDate(date);
    const timeSuffix = dateTime.toLocaleString(DateTime.TIME_SIMPLE);
    const diffToNow = dateTime.diff(now, 'minutes');

    if (diffToNow.minutes <= 60) {
      return intl.formatRelativeTime(Math.round(diffToNow.minutes), 'minute');
    } else if (dateTime < now.endOf('day').plus({ days: 1 })) {
      const dowPrefix = capitalize(dateTime.toRelativeCalendar());
      return `${dowPrefix}, ${timeSuffix}`;
    } else if (dateTime < now.endOf('week')) {
      const dowPrefix = dateTime.toFormat('cccc');
      return `${dowPrefix}, ${timeSuffix}`;
    } else {
      return dateTime.toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
    }
  };
  const selectedDeliveryAddress =
    checkout?.deliveryAddress ||
    deliveryAddresses?.find(
      (address) => address?.id === checkout?.deliveryAddressId,
    );

  const distanceFromStore = calculateDistance(
    store?.address?.coordinates,
    selectedDeliveryAddress?.coordinates,
  );
  const rightDeliveryFee =
    selectedDeliveryAddress &&
    deliveryFees?.length &&
    deliveryFees?.find(
      (fee) =>
        fee.fromRadius <= distanceFromStore &&
        distanceFromStore <= fee.toRadius,
    );

  // Check if distance is below the minimum delivery range (first tier's fromRadius)
  const minDeliveryRadius =
    deliveryFees?.length > 0
      ? Math.min(...deliveryFees.map((fee) => fee.fromRadius))
      : 0;
  const isBelowMinDeliveryRadius =
    selectedDeliveryAddress &&
    deliveryFees?.length > 0 &&
    distanceFromStore < minDeliveryRadius;

  // Order type fee: for delivery, use delivery fee from radius; for others, use service fee from order config
  const orderTypeFee = isDeliveryOrder
    ? rightDeliveryFee
      ? rightDeliveryFee?.fee
      : 0
    : serviceFee;

  useEffect(() => {
    if (
      (isDeliveryOrder || isCateringOrder) &&
      store &&
      checkout?.deliveryAddressId
    ) {
      if (selectedDeliveryAddress) {
        setIsWithinDeliveryRadius(
          rightDeliveryFee?.fromRadius <= distanceFromStore &&
            distanceFromStore <= rightDeliveryFee?.toRadius,
        );
      }
    }
  }, [
    store?.address,
    selectedDeliveryAddress,
    deliveryFees,
    checkout?.deliveryAddressId,
    checkout?.orderType,
    rightDeliveryFee,
    distanceFromStore,
  ]);

  return (
    <>
      <ModalSheet
        isOpen={isOpen && cart?.length > 0}
        closeModal={() => setIsCartModalOpen(false)}
        title={intl.formatMessage({ id: 'cartTitle' })}
        footer={
          <div className="w-100">
            {isOrderOnly && (
              <div className="mb-1">
                <TermsAndConditionsText order={order} />
              </div>
            )}

            {itemsTotal > 0 && itemsTotal < 0.5 ? (
              <Alert className="d-flex p-50 mb-1" color="warning">
                <span className="font-small-3">
                  <FormattedMessage
                    id="minOrderAmountWarning"
                    values={{
                      storeName: store?.name,
                      minOrderAmount: intl.formatNumber(0.5, {
                        format: 'priceCurrency',
                      }),
                    }}
                  />
                </span>
              </Alert>
            ) : (
              isDeliveryOrder &&
              rightDeliveryFee?.minOrderAmount > itemsTotal && (
                <Alert className="d-flex p-50 mb-1" color="warning">
                  <span className="font-small-3">
                    <FormattedMessage
                      id="cartMinOrderAmountWarning"
                      values={{
                        storeName: store?.name,
                        minOrderAmount: intl.formatNumber(
                          rightDeliveryFee?.minOrderAmount,
                          { format: 'priceCurrency' },
                        ),
                      }}
                    />
                  </span>
                </Alert>
              )
            )}

            {hasCartPosConflict && (
              <Alert className="d-flex p-50 mb-1" color="warning">
                <span className="font-small-3">
                  <FormattedMessage id="cartPosConflictWarning" />
                </span>
              </Alert>
            )}

            {!isCartAvailableNow && (
              <Alert
                data-testid="cartItemsUnavailableNowWarning"
                className="d-flex p-50 mb-1"
                color="warning"
              >
                <span className="font-small-3">
                  <FormattedMessage id="cartItemsUnavailableNowError" />
                </span>
              </Alert>
            )}

            <SaveSubmitButton
              data-testid="proceedToCheckoutButton"
              type="submit"
              color="primary"
              className="btn-lg"
              onClick={() => formRef?.current.handleSubmit()} // this button is outside the AvForm. So trigger submit programmatically.
              isSubmitting={isLoading}
              disabled={
                isLoading ||
                hasCartPosConflict ||
                !isCartAvailableNow ||
                !isItemsAvailableAtRequestedTime ||
                !checkout?.orderType ||
                !checkout?.checkoutMethod ||
                (isDeliveryOrder &&
                  (rightDeliveryFee?.minOrderAmount > itemsTotal ||
                    !checkout?.deliveryAddressId ||
                    !isWithinDeliveryRadius)) ||
                (isPickupOrder &&
                  !kiosk &&
                  preOrderHours > 0 &&
                  !checkout?.pickupRequestedAt) ||
                (isCateringOrder &&
                  (!checkout?.deliveryRequestedAt ||
                    (checkout?.deliveryAddressId &&
                      !isWithinDeliveryRadius))) ||
                (itemsTotal > 0 && itemsTotal < 0.5)
              }
              messageId={
                isCateringOrder
                  ? 'requestOfferLabel'
                  : isOrderOnly
                  ? 'checkoutButtonLabel'
                  : 'proceedToCheckoutLabel'
              }
              messageValues={{
                price: intl.formatNumber(orderTypeFee + itemsTotal, {
                  format: 'priceCurrency',
                }),
                total: intl.formatNumber(orderTypeFee + itemsTotal, {
                  format: 'priceCurrency',
                }),
              }}
            />
          </div>
        }
        disableEnterToSubmit={true}
      >
        <div className="px-1">
          {preparedSharedCarts?.length > 0 && (
            <Nav className="shadow-none" tabs>
              <NavItem style={{ maxWidth: '25%' }}>
                <NavLink
                  className={classnames(
                    'text-decoration-none shared-carts',
                    'text-truncate',
                    { active: activeTab === '1' },
                  )}
                  onClick={() => toggleActiveTab('1')}
                >
                  <span>
                    {customerProfile?.displayName ||
                      intl.formatMessage({ id: 'youLabel' })}
                  </span>
                </NavLink>
              </NavItem>

              {preparedSharedCarts?.map((cart, index) => (
                <NavItem key={index} style={{ maxWidth: '25%' }}>
                  <NavLink
                    className={classnames(
                      'text-decoration-none shared-carts text-truncate',
                      { active: activeTab === (index + 2).toString() },
                    )}
                    onClick={() => {
                      toggleActiveTab((index + 2).toString());
                    }}
                  >
                    {cart?.displayName ||
                      intl.formatMessage(
                        { id: 'guestNumberLabel' },
                        {
                          number: cart.customerProfileId
                            .replace(/\D/g, '')
                            .slice(0, 3),
                        },
                      )}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          )}
        </div>

        {preparedSharedCarts?.length > 0 && <hr />}

        <AvForm ref={formRef} onValidSubmit={handleCreateOrder}>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              {courseCart ? (
                <>
                  <div className="px-1">
                    {getCourseCartDivider(0)}
                    <CourseCartContainer
                      courseCart={courseCart}
                      axis="y"
                      onSortEnd={onCourseSortEnd}
                      helperClass="sortable-on-drag"
                      useDragHandle={true}
                    />
                  </div>
                </>
              ) : (
                <div className="px-1">
                  {cart?.map((orderItem, index) => (
                    <OrderItemLine
                      key={index}
                      orderItem={orderItem}
                      context="cart"
                      handleEditItemAdditions={handleEditItemAdditions}
                    />
                  ))}
                </div>
              )}

              <hr />
              <div className="px-1 px-1">
                <div>
                  {enableCartComment && (
                    <>
                      {' '}
                      <span className="font-small-3 text-primary">
                        <FormattedMessage id="cartCommentTitle" />
                      </span>
                      <AvInput
                        name="cartComment"
                        className="bg-transparent font-small-3 line-height-15 mt-50"
                        placeholder={intl.formatMessage({
                          id: 'cartCommentPlaceholder',
                        })}
                        value={checkout?.cartComment}
                        onChange={(e) => {
                          setCheckoutDebounced({ cartComment: e.target.value });
                        }}
                        validate={{ maxLength: { value: 250 } }}
                      />
                      <hr />{' '}
                    </>
                  )}

                  <SelectRelevo />

                  <SelectOrderType />

                  <SelectCheckoutMethod />

                  {showDiscountInCart && (
                    <>
                      <hr />
                      <span className="font-small-3 text-primary">
                        <FormattedMessage id="discountCodeCheckoutLabel" />
                      </span>
                      <InputGroup className="mt-50">
                        <Input
                          type="text"
                          data-testid="cartDiscountCodeInput"
                          className="bg-transparent font-small-3 line-height-15"
                          placeholder={intl.formatMessage({
                            id: 'discountCodePlaceHolder',
                          })}
                          value={discountCodeInput}
                          invalid={discountCodeInvalid}
                          // Enter applies the code instead of submitting the cart.
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleApplyCartDiscount();
                            }
                          }}
                          onChange={(e) => {
                            if (discountCodeInvalid)
                              setDiscountCodeInvalid(false);
                            const value = e.target.value;
                            setDiscountCodeInput(value);
                            // Editing an applied code un-commits it so a stale
                            // code is never sent at checkout; require re-apply.
                            if (
                              checkout?.discountCode &&
                              checkout.discountCode !== value
                            ) {
                              setCheckout({ discountCode: '' });
                            }
                          }}
                        />
                        <InputGroupAddon addonType="append">
                          {discountCodeInput && (
                            <Button
                              outline
                              color="dark"
                              size="sm"
                              aria-label={intl.formatMessage({
                                id: 'removeDiscountCode',
                              })}
                              onClick={handleRemoveCartDiscount}
                            >
                              <Icon.X size={15} />
                            </Button>
                          )}
                          <Button
                            color="primary"
                            size="sm"
                            data-testid="cartDiscountCodeApply"
                            disabled={
                              !discountCodeInput ||
                              checkout?.discountCode === discountCodeInput
                            }
                            aria-label={intl.formatMessage({
                              id: 'discountCodeCheckoutLabel',
                            })}
                            onClick={handleApplyCartDiscount}
                          >
                            <Icon.Check size={15} />
                          </Button>
                        </InputGroupAddon>
                      </InputGroup>
                      {discountCodeInvalid && (
                        <small className="text-danger">
                          <FormattedMessage id="discountCodeError" />
                        </small>
                      )}
                      {!discountCodeInvalid &&
                        !!checkout?.discountCode &&
                        checkout.discountCode === discountCodeInput && (
                          // The code is validated by the backend when the order
                          // is placed (there is no order to validate against
                          // yet), so we only confirm it will be applied — never
                          // claim success that could be a lie for a bad code.
                          <small className="text-muted">
                            <FormattedMessage id="discountCodeWillApplyAtCheckout" />
                          </small>
                        )}
                    </>
                  )}

                  {enablePagerNumber && kiosk && (
                    <>
                      <hr />
                      <span className="font-small-3 text-primary">
                        <FormattedMessage id="pagerNumberTitle" />
                      </span>
                      <AvInput
                        name="pagerNumber"
                        className="bg-transparent font-small-3 line-height-15 mt-50"
                        placeholder={intl.formatMessage({
                          id: 'pagerNumberLabel',
                        })}
                        value={checkout?.pagerNumber}
                        onChange={(e) => {
                          setCheckoutDebounced({
                            pagerNumber: e.target.value,
                          });
                        }}
                        required
                      />
                    </>
                  )}
                  <hr />
                  {!!customerFieldsQty && (
                    <>
                      <div>
                        <span className="font-small-3 text-primary">
                          <FormattedMessage id="customerOrderInfoText" />
                        </span>
                        <div className="mt-50">
                          <Row>
                            {showCustomerNameField && (
                              <Col
                                xs={customerFieldsQty > 1 ? 6 : 12}
                                className={classnames({
                                  'pr-50': customerFieldsQty > 1,
                                })}
                              >
                                <FormField
                                  groupClassName="mb-1"
                                  data-testid="nameInput"
                                  autoComplete="name"
                                  propertyName="name"
                                  messageId="name"
                                  object={customerProfile}
                                  value={checkout?.customerName}
                                  onChange={(e) => {
                                    const customerName = e.target.value;
                                    if (
                                      customerName !== checkout.customerName
                                    ) {
                                      setCheckout({ customerName });
                                      patchCustomerProfileDebounced(
                                        customerProfileId,
                                        { name: customerName },
                                        setCustomerProfile,
                                      );
                                    }
                                  }}
                                  hideFloatingLabel
                                  showPlaceHolder
                                  required
                                />
                              </Col>
                            )}

                            {showCustomerTelField && (
                              <Col
                                xs={customerFieldsQty > 1 ? 6 : 12}
                                className={
                                  showCustomerNameField
                                    ? 'pl-50'
                                    : customerFieldsQty > 1
                                    ? 'pr-50'
                                    : null
                                }
                              >
                                <TelFormField
                                  groupClassName="mb-1"
                                  data-testid="telInput"
                                  autoComplete="tel"
                                  propertyName="tel"
                                  messageId="tel"
                                  object={customerProfile}
                                  value={checkout?.customerTel}
                                  onChange={(customerTel) => {
                                    if (customerTel !== checkout.customerTel) {
                                      setCheckout({ customerTel });
                                      patchCustomerProfileDebounced(
                                        customerProfileId,
                                        { tel: customerTel },
                                        setCustomerProfile,
                                      );
                                    }
                                  }}
                                  hideFloatingLabel
                                  showPlaceHolder
                                  required
                                />
                              </Col>
                            )}

                            {showCustomerEmailField && (
                              <Col
                                xs={customerFieldsQty === 2 ? 6 : 12}
                                className={classnames({
                                  'pl-50': customerFieldsQty === 2,
                                })}
                              >
                                <FormField
                                  groupClassName="mb-1"
                                  data-testid="emailInput"
                                  type="email"
                                  autoComplete="email"
                                  propertyName="email"
                                  messageId="email"
                                  object={customerProfile}
                                  value={checkout?.customerEmail}
                                  onChange={(e) => {
                                    const customerEmail = e.target.value;
                                    if (
                                      customerEmail !== checkout.customerEmail
                                    ) {
                                      setCheckout({ customerEmail });
                                      patchCustomerProfileDebounced(
                                        customerProfileId,
                                        { email: customerEmail },
                                        setCustomerProfile,
                                      );
                                    }
                                  }}
                                  hideFloatingLabel
                                  showPlaceHolder
                                  required
                                />
                              </Col>
                            )}

                            {showCustomerRoomNumberField && (
                              <Col xs={12}>
                                <FormField
                                  groupClassName="mb-1"
                                  data-testid="roomNumberInput"
                                  type="number"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  autoComplete="off"
                                  propertyName="roomNumber"
                                  messageId="roomNumber"
                                  object={{}}
                                  value={checkout?.customerRoomNumber}
                                  onChange={(e) => {
                                    const customerRoomNumber =
                                      e.target.value.replace(/[^0-9]/g, '');
                                    if (
                                      customerRoomNumber !==
                                      checkout.customerRoomNumber
                                    ) {
                                      setCheckout({ customerRoomNumber });
                                    }
                                  }}
                                  hideFloatingLabel
                                  showPlaceHolder
                                  required
                                />
                              </Col>
                            )}
                          </Row>
                        </div>
                      </div>
                      <hr className="mt-0" />
                    </>
                  )}
                  {showTableDropdown &&
                    checkout?.orderType === ORDER_TYPE_SELF_SERVICE &&
                    store?.selfServiceOrderConfig?.tableSelectionMode &&
                    store?.selfServiceOrderConfig?.tableSelectionMode !==
                      'never' && (
                      <>
                        <span className="font-small-3 text-primary">
                          <FormattedMessage id="askForTableLabel" />
                        </span>
                        <DropdownField
                          groupClassName="mt-50"
                          required
                          isClearable={true}
                          isMulti={false}
                          options={tables}
                          propertyName="tableId"
                          getOptionValue={(table) => table?.id}
                          emptyValue={null}
                          getOptionLabel={(table) => table?.name}
                          onChange={(table) => {
                            setCheckoutDebounced({ tableId: table?.id });
                          }}
                          isKiosk={kiosk}
                          object={checkout}
                          isSearchable={!kiosk}
                        />
                      </>
                    )}
                  {!kiosk &&
                    (isDeliveryOrder || isCateringOrder || isPickupOrder) && (
                      <>
                        <span className="font-small-3 text-primary">
                          <FormattedMessage
                            id={
                              isPickupOrder
                                ? 'pickupRequestedAtTitle'
                                : isDeliveryOrder
                                ? 'deliveryRequestedAtOptionalTitle'
                                : 'deliveryRequestedAtTitle'
                            }
                          />
                        </span>
                        <div className="mt-50">
                          {store && checkout && (
                            <DateTimeField
                              setIsDateTimeFieldValid={setIsDateTimeFieldValid}
                              object={checkout}
                              className="text-center"
                              options={{
                                minDate:
                                  isPickupOrder && accumulatedOrdersCsvTime
                                    ? handleAccumulatedOrdersCsvTime(
                                        accumulatedOrdersCsvTime,
                                      )
                                    : new Date(),
                                maxDate: maxDate, // Use the validated maxDate variable
                              }}
                              onChange={(date, isValid) => {
                                const propertyName = isPickupOrder
                                  ? 'pickupRequestedAt'
                                  : 'deliveryRequestedAt';
                                const value =
                                  date && isValid
                                    ? date.toISOString()
                                    : undefined;
                                setCheckout({ [propertyName]: value });
                              }}
                              serviceTimes={store?.serviceTimes}
                              store={store}
                              additionalValidation={(date) =>
                                isCartOrderConditionsSatisfiedAtDate(
                                  cart,
                                  checkout?.orderType,
                                  date,
                                )
                              }
                              additionalInvalidMessageId="itemUnavailableAtRequestedTimeError"
                              propertyName={
                                isPickupOrder
                                  ? 'pickupRequestedAt'
                                  : 'deliveryRequestedAt'
                              }
                              dataTestId={
                                isPickupOrder
                                  ? 'pickupRequestedAt'
                                  : 'deliveryRequestedAt'
                              }
                              showRelativeTime
                              required={isCateringOrder || isPickupOrder}
                            />
                          )}
                          {!isDateTimeFieldValid &&
                            !isStoreOpenAtRequestedTime && (
                              <div className="text-center mt-50">
                                <span className="font-small-3 text-warning">
                                  <FormattedMessage
                                    id="storeClosedRelativeTimeText"
                                    values={{
                                      storeName: store?.name,
                                      timeMessage: formatRelative(
                                        getNextStart(store?.serviceTimes)
                                          ?.startAt,
                                      ),
                                    }}
                                  />
                                </span>
                              </div>
                            )}
                          {/* Not gated on isDateTimeFieldValid: the submit button
                              is disabled on this same condition, so the reason
                              must always be visible next to it. */}
                          {isStoreOpenAtRequestedTime &&
                            !isItemsAvailableAtRequestedTime && (
                              <div className="text-center mt-50">
                                <span className="font-small-3 text-warning">
                                  <FormattedMessage id="itemUnavailableAtRequestedTimeError" />
                                </span>
                              </div>
                            )}
                        </div>
                        <hr />
                      </>
                    )}

                  {(isDeliveryOrder || isCateringOrder) && (
                    <>
                      {query.has('deliveryAddress') && (
                        <Alert
                          onClick={() => {
                            setCheckout({ deliveryAddressId: undefined });
                            setCreateDeliveryAddressModalData({
                              openCartModal: true,
                              hasDeliveryQuery: query.has('deliveryAddress'),
                            });
                            setIsCreateDeliveryAddressModalOpen(true);
                          }}
                          className="px-1 py-50 py-lg-1 d-block d-md-flex"
                          color="warning"
                        >
                          <span className="align-self-center">
                            <Icon.AlertCircle size={20} className="warning" />
                          </span>
                          <span className="mr-md-2 align-self-center">
                            <FormattedMessage
                              id="deliveryAddressWarning"
                              values={{ storeName: store.name }}
                            />
                          </span>
                        </Alert>
                      )}

                      <div className="mt-1">
                        <span className="font-small-3 text-primary">
                          <FormattedMessage id="whichDeliveryAddressLabel" />
                        </span>
                        <OptionsList
                          isMulti={false}
                          options={deliveryAddresses}
                          values={
                            checkout?.deliveryAddressId && [
                              checkout.deliveryAddressId,
                            ]
                          }
                          getOptionKey={({ id }) => id}
                          getOptionValue={(deliveryAddress) =>
                            [
                              deliveryAddress.companyName ||
                                [
                                  deliveryAddress.firstName,
                                  deliveryAddress.lastName,
                                ].join(' '),
                              deliveryAddress.line1,
                              deliveryAddress.line2,
                              [deliveryAddress.zip, deliveryAddress.city].join(
                                ' ',
                              ),
                            ]
                              .filter(Boolean)
                              .join(', ')
                          }
                          onChange={(deliveryAddressId) =>
                            checkout?.deliveryAddressId !== deliveryAddressId &&
                            setCheckout({ deliveryAddressId })
                          }
                          handleCreateNewOption={() => {
                            setCheckout({
                              deliveryAddressId: undefined,
                            });
                            setCreateDeliveryAddressModalData({
                              openCartModal: true,
                            });
                            setIsCreateDeliveryAddressModalOpen(true);
                          }}
                          propertyName="deliveryAddressId"
                          createNewOptionMessageId="createNewDeliveryAddressTitle"
                          validationErrorMessageId="addressMissingError"
                          customError={
                            !isWithinDeliveryRadius &&
                            checkout?.deliveryAddressId && (
                              <Alert
                                className="d-flex p-50 mt-50 mb-25"
                                color="warning"
                              >
                                <span className="font-small-3">
                                  <FormattedMessage
                                    id={
                                      isBelowMinDeliveryRadius
                                        ? 'cartBelowMinDeliveryRadiusWarning'
                                        : 'cartMinOrderRadiusWarning'
                                    }
                                    values={{
                                      storeName: store?.name,
                                      minDeliveryRadius: minDeliveryRadius,
                                      deliveryRadius: (
                                        deliveryFees || []
                                      ).reduce(
                                        (max, obj) =>
                                          Math.max(max, obj?.toRadius || 0),
                                        0,
                                      ),
                                    }}
                                  />
                                </span>
                              </Alert>
                            )
                          }
                          required
                        />
                      </div>
                      <hr />
                    </>
                  )}
                  {isCateringOrder && (
                    <>
                      <div className="mt-1">
                        <span className="font-small-3 text-primary">
                          <FormattedMessage id="whichBillingAddressLabel" />
                        </span>
                        <OptionsList
                          isMulti={false}
                          options={billingAddresses}
                          values={
                            checkout?.billingAddressId && [
                              checkout.billingAddressId,
                            ]
                          }
                          getOptionKey={({ id }) => id}
                          getOptionValue={(billingAddress) =>
                            [
                              billingAddress.companyName ||
                                [
                                  billingAddress.firstName,
                                  billingAddress.lastName,
                                ].join(' '),
                              billingAddress.line1,
                              billingAddress.line2,
                              [billingAddress.zip, billingAddress.city].join(
                                ' ',
                              ),
                            ]
                              .filter(Boolean)
                              .join(', ')
                          }
                          onChange={(billingAddressId) =>
                            checkout?.billingAddressId !== billingAddressId &&
                            setCheckout({ billingAddressId })
                          }
                          handleCreateNewOption={() => {
                            setCheckout({ billingAddressId: undefined });
                            setCreateBillingAddressModalData({
                              openCartModal: true,
                            });
                            setIsCreateBillingAddressModalOpen(true);
                          }}
                          createNewOptionMessageId="createNewBillingAddressTitle"
                          validationErrorMessageId="addressMissingError"
                          propertyName="billingAddressId"
                          required={isCateringOrder}
                        />
                      </div>
                      <hr />
                    </>
                  )}
                  {isCateringOrder && (
                    <>
                      <span className="font-small-3 text-primary">
                        <FormattedMessage id="numberOfGuestsText" />
                      </span>
                      <FormField
                        hideFloatingLabel
                        className="mt-50"
                        type="number"
                        propertyName="guestQty"
                        messageId="personsQtyLabel"
                        object={checkout}
                        valueParser={(value) => {
                          const regex = /^[0-9]+$/;
                          if (regex.test(value)) {
                            const parsedValue = parseInt(value);
                            return parsedValue >= 1 ? parsedValue : {}; // {} is definitely not a number
                          } else {
                            return {}; // {} is definitely not a number
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          const guestQty = value ? parseInt(value, 10) : 0;
                          if (guestQty !== checkout.guestQty) {
                            setCheckoutDebounced({ guestQty });
                          }
                        }}
                        required
                      />
                      <hr />
                    </>
                  )}

                  <div className="d-flex justify-content-between">
                    <span className="font-medium-1">
                      <FormattedMessage id="subtotalLabel" />
                    </span>
                    <span className="font-medium-1">
                      <FormattedNumber
                        value={itemsTotal}
                        format="priceCurrency"
                      />
                    </span>
                  </div>

                  {isDeliveryOrder && rightDeliveryFee && (
                    <div className="d-flex justify-content-between">
                      <span className="font-medium-1">
                        <FormattedMessage id="deliveryFeeLabel" />
                      </span>
                      <span className="font-medium-1">
                        <FormattedNumber
                          value={rightDeliveryFee?.fee}
                          format="priceCurrency"
                        />
                      </span>
                    </div>
                  )}
                  {/* Show service fee for any order type if configured */}
                  {serviceFee > 0 && (
                    <div className="d-flex justify-content-between">
                      <span className="font-medium-1">
                        <FormattedMessage id="serviceFeeLabel" />
                      </span>
                      <span className="font-medium-1">
                        <FormattedNumber
                          value={serviceFee}
                          format="priceCurrency"
                        />
                      </span>
                    </div>
                  )}

                  <div className="d-flex justify-content-between text-bold-500 black">
                    <span className="font-medium-1 text-bold-500">
                      <FormattedMessage id="totalLabel" />
                    </span>
                    <span className="font-medium-1 text-bold-500">
                      <FormattedNumber
                        value={orderTypeFee + itemsTotal}
                        format="priceCurrency"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </TabPane>

            {preparedSharedCarts?.map((sharedCart, index) => (
              <TabPane key={index} tabId={(index + 2).toString()}>
                {sharedCart?.items?.length > 0 ? (
                  sharedCart?.items?.map((orderItem, index) => (
                    <div key={index} className="px-1">
                      <OrderItemLine
                        key={index}
                        orderItem={orderItem}
                        context="shared_cart"
                        handleEditItemAdditions={handleEditItemAdditions}
                      />
                    </div>
                  ))
                ) : (
                  <Empty className="my-2" titleId="emptyAdditionsListTitle" />
                )}
              </TabPane>
            ))}
          </TabContent>
        </AvForm>
      </ModalSheet>

      <div
        className={classnames('mini-cart-container', {
          active: cart?.length > 0 && !isOpen,
          'cart-changed': showItemAddedAnimation,
        })}
        onClick={() => setIsCartModalOpen(true)}
        onDrag={() => setIsCartModalOpen(true)}
        onAnimationEnd={() => setShowItemAddedAnimation(false)}
      >
        <h1 className="font-medium-1 m-0">
          <ShoppingBag
            data-testid="miniCartContainer"
            size={18}
            className="mr-25"
          />
          <FormattedMessage
            id="cartTitleWithPriceLabel"
            values={{
              price: intl.formatNumber(orderTypeFee + itemsTotal, {
                format: 'priceCurrency',
              }),
            }}
          />
        </h1>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isCartModalOpen,
  cart: state.store.cart,
  store: state.store.store,
  menuEntriesData: state.store.menuEntriesData,
  table: state.store.table,
  order: state.store.order,
  checkout: state.store.checkout,
  me: state.me.me,
  paymentMethods: state.me.paymentMethods,
  billingAddresses: state.me.billingAddresses,
  deliveryAddresses: state.me.deliveryAddresses,
  sharedCarts: state.store.sharedCarts,
  kiosk: state.store.kiosk,
  tables: state.store.tables,
  items: state.store.items,
});

export default connect(mapStateToProps, {
  setIsCartModalOpen,
  setCheckout,
  setIsTipModalOpen,
  setIsChoosePaymentMethodModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  fetchOnAuthenticated,
  setOrder,
  setOrderHash,
  setCart,
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  setIsCheckoutModalOpen,
  setSelectAdditionsModalData,
  setIsSelectAdditionsModalOpen,
  removeCartItem,
  setIsCreateBillingAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsCreateDeliveryAddressModalOpen,
  setCreateDeliveryAddressModalData,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
})(CartModal);
